export enum CompressionTypes {
	NONE = 'NONE',
	ZIP = 'ZIP'
}
